import { z } from "zod";

/**
 * `PROSPECTS-COUNTS` (A-H, 2 November; record `claude/prospects-scope-2026-11-02.md`): **how many buyers have kept this car, anonymously.** `GET /api/v1/me/vehicles/{vehicleId}/interest` answers the dealership
 * that owns the car with ONE number and no identity: `savedCount` is the number of rows of `catalog.vehicle_favourites` on the car NOW (a removed favourite is deleted, so a count is the current saves,
 * never a history). The answer has no other key: a strict schema refuses a name, a phone, a client id or a list of them, so none can be added by one side only.
 *
 * **Views are NOT served**: nothing records a car being viewed (no table, no event, no log), and a counter on the public read path is not built before the pilot. The key does not exist.
 */
const build = (object: typeof z.strictObject) =>
  object({
    vehicleId: z.uuid(),
    /** The buyers who have kept this car at this moment. Whole, never negative. */
    savedCount: z.number().int().min(0),
  });

export const vehicleInterestAnswerSchema = build(z.strictObject);
/** The dealer client's reading of the same answer: unknown keys tolerated. */
export const vehicleInterestLenientReadSchema = build(z.looseObject);
export type VehicleInterestAnswer = z.infer<typeof vehicleInterestAnswerSchema>;
